import Grid from '@mui/material/Grid';
import { useState } from 'react';

import {
  DrawerAction,
  FilterAction,
  OrderListSettingsAction,
  SearchBar,
  SoundAction,
} from '@frontend/components';
import { usePersistentUiSettings } from '@frontend/utils';

import type { OrdersGroupByFieldModel, OrdersSortDirection } from '../hooks';
import { FilterDialog, type OrderFilterInput } from './filter';
import { OrderGroupingSelect } from './order-grouping-select.component';

export interface OrderHeaderActionProps {
  onSearch(input: string): void;
  onFilter?(input: OrderFilterInput): void;
  onGroupByChange(groupBy: OrdersGroupByFieldModel): void;
  onSortDirectionChange(sort: OrdersSortDirection): void;
  selectedGroupBy: OrdersGroupByFieldModel;
  selectedSortDirection: OrdersSortDirection;
}

export const OrderHeaderAction = (props: OrderHeaderActionProps) => {
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const {
    ordersPage: { filter },
  } = usePersistentUiSettings();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid>
        <DrawerAction />
      </Grid>

      <Grid>
        <OrderGroupingSelect
          onGroupByChange={props.onGroupByChange}
          onSortDirectionChange={props.onSortDirectionChange}
          selected={props.selectedGroupBy}
          sortDirection={props.selectedSortDirection}
        />
      </Grid>

      <Grid size="grow" alignContent="center" minWidth={124}>
        <SearchBar onSearch={props.onSearch} />
      </Grid>

      <Grid>
        <SoundAction />
      </Grid>

      <Grid>
        <FilterAction onClick={() => setShowFilterDialog(true)} />
      </Grid>

      <Grid>
        <OrderListSettingsAction />
      </Grid>

      <FilterDialog
        initialValues={{
          placeIds: filter?.placeIds ? filter.placeIds : [],
          preOrder: filter?.preOrder?.toString() ?? '',
          status: filter?.status,
          period: filter?.period ?? 'TODAY',
        }}
        open={showFilterDialog}
        onClose={() => setShowFilterDialog(false)}
        onSubmit={props.onFilter}
      />
    </Grid>
  );
};
